import React from 'react';
import { Navigate } from 'react-router-dom';
import AdminRoute from '../components/AdminRoute';

// Lazy-loaded admin pages
const AdminDashboard = React.lazy(() => import('../pages/admin/AdminDashboard'));
const AdminLogin = React.lazy(() => import('../pages/admin/AdminLogin'));
const AdminRegistrations = React.lazy(() => import('../pages/admin/AdminRegistrations'));
const AdminUsers = React.lazy(() => import('../pages/admin/AdminUsers'));
const AdminTradies = React.lazy(() => import('../pages/admin/AdminTradies'));
const TradieProfile = React.lazy(() => import('../pages/TradieProfile'));
const AdminAds = React.lazy(() => import('../pages/admin/AdminAds'));
const AdminAdvertisers = React.lazy(() => import('../pages/admin/AdminAdvertisers'));
const AdminAnalytics = React.lazy(() => import('../pages/admin/AdminAnalytics'));
const AdminBilling = React.lazy(() => import('../pages/admin/AdminBilling'));
const AdminCRMAccount = React.lazy(() => import('../pages/admin/AdminCRMAccount'));
const AdminSalesCRM = React.lazy(() => import('../pages/admin/AdminSalesCRM'));
const AdminClaims = React.lazy(() => import('../pages/admin/AdminClaims'));
const AdminCases = React.lazy(() => import('../pages/admin/AdminCases'));
const CaseDetail = React.lazy(() => import('../pages/admin/CaseDetail'));
const AdminTradeRates = React.lazy(() => import('../pages/admin/AdminTradeRates'));

const adminRoutes = [
  { path: '/admin/login', element: <AdminLogin /> },
  { path: '/admin/dashboard', element: <AdminRoute><AdminDashboard /></AdminRoute> },
  { path: '/admin/registrations', element: <AdminRoute><AdminRegistrations /></AdminRoute> },
  { path: '/admin/users', element: <AdminRoute><AdminUsers /></AdminRoute> },
  { path: '/admin/tradies', element: <AdminRoute><AdminTradies /></AdminRoute> },
  { path: '/admin/tradie/:id', element: <AdminRoute allowSales={true}><TradieProfile /></AdminRoute> },
  { path: '/admin/ads', element: <AdminRoute><AdminAds /></AdminRoute> },
  { path: '/admin/advertisers', element: <AdminRoute><AdminAdvertisers /></AdminRoute> },
  { path: '/admin/advertisers/:advertiserId', element: <AdminRoute><AdminAdvertisers /></AdminRoute> },
  { path: '/admin/billing', element: <AdminRoute><AdminBilling /></AdminRoute> },
  { path: '/admin/claims', element: <AdminRoute allowAgent={true}><AdminClaims /></AdminRoute> },
  { path: '/admin/cases/:caseId', element: <AdminRoute allowAgent={true}><CaseDetail /></AdminRoute> },
  { path: '/admin/cases', element: <AdminRoute allowAgent={true}><AdminCases /></AdminRoute> },
  { path: '/admin/crm/account/:tradieId', element: <AdminRoute><AdminCRMAccount /></AdminRoute> },
  { path: '/admin/sales', element: <AdminRoute allowSales={true}><AdminSalesCRM /></AdminRoute> },
  { path: '/admin/analytics', element: <AdminRoute><AdminAnalytics /></AdminRoute> },
  { path: '/admin/trade-rates', element: <AdminRoute><AdminTradeRates /></AdminRoute> },
  { path: '/admin', element: <AdminRoute><AdminDashboard /></AdminRoute> },
];

export default adminRoutes;
